export default class {
  inputClose () {
    if (this.timeStart) {
      this.$emit('update:timeStart', undefined)
      this.$emit('update:timeEnd', undefined)
    }
  }
}